
import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cajaChicaService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async Getcorrelativo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica/correlativo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };




    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-chica`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async cerrar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica/cerrar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async anular(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async devolver(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-chica/devolver`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async arquearCaja(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-chica/arqueo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new cajaChicaService();